__turbopack_context__.v({
  "blogContainer": "Header-module__ax4oKa__blogContainer" + " " + "Header-module__ax4oKa__container",
  "blogIndexContainer": "Header-module__ax4oKa__blogIndexContainer",
  "blogRecordContainer": "Header-module__ax4oKa__blogRecordContainer",
  "bottomStrip": "Header-module__ax4oKa__bottomStrip",
  "category": "Header-module__ax4oKa__category",
  "container": "Header-module__ax4oKa__container",
  "content": "Header-module__ax4oKa__content",
  "contentSpacing": "Header-module__ax4oKa__contentSpacing",
  "contentWrap": "Header-module__ax4oKa__contentWrap",
  "copy": "Header-module__ax4oKa__copy",
  "ctaLink": "Header-module__ax4oKa__ctaLink",
  "headerWrap": "Header-module__ax4oKa__headerWrap",
  "heroCtaContainer": "Header-module__ax4oKa__heroCtaContainer",
  "iconWrapper": "Header-module__ax4oKa__iconWrapper",
  "imageCredit": "Header-module__ax4oKa__imageCredit",
  "linksContainer": "Header-module__ax4oKa__linksContainer",
  "overlay": "Header-module__ax4oKa__overlay",
  "subtitle": "Header-module__ax4oKa__subtitle",
  "trustBoxContainer": "Header-module__ax4oKa__trustBoxContainer",
  "trustRow": "Header-module__ax4oKa__trustRow",
  "trustpilot": "Header-module__ax4oKa__trustpilot",
  "trustpilotStars": "Header-module__ax4oKa__trustpilotStars",
});
